var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.1075C0 12.5469 0.338366 12.8691 0.776722 12.8691H6.08756L3.30382 20.5746C2.89848 21.7067 4.03699 22.315 4.76688 21.3966L13.3827 10.4306C13.555 10.1972 13.6487 9.98348 13.6487 9.73579C13.6487 9.29637 13.3199 8.97417 12.872 8.97417H7.56115L10.3449 1.26866C10.7598 0.136596 9.61173 -0.471644 8.88184 0.446745L0.266011 11.4126C0.0936657 11.6461 0 11.8598 0 12.1075Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.67ae872197c57c0c92a0f4ae3410d300.svg";
export { ForwardRef as ReactComponent };